export const SCREENS = {
    MAIN_MENU: "MAIN_MENU",
    GAME: "GAME",
    SCORE_SCREEN: "SCORE_SCREEN",
    SETTINGS_SCREEN: "SETTINGS_SCREEN"
};
